<template>
  <SidebarMenu />
</template>

<script>
import SidebarMenu from './components/sidebar-menu/SidebarMenu.vue'

export default {
  components: {
    SidebarMenu
  }
}
</script>

<style>
</style>
